import {put, call } from 'redux-saga/effects';
import { aoiServices } from "../Service/aoiService";
import { mapConstants } from "../actions/constants/mapConstants";

function* userareaSaga(request:any) {
    try {
        const response = yield call(aoiServices.userinfoGetAll, request.payload);
        if(response.statusCode === 200){
            yield put({
                type:mapConstants.userAreaGetAllSuccess,
                payload : response.resultObject

            });
        }else{
            yield put({
                type:mapConstants.userAreaGetAllFailure,
                payload: response.status
            });
        }      
      } catch (error) {
        yield put({
            type:mapConstants.userAreaGetAllFailure,
            payload: error
        });
      }
  }

  function* favoriteSaga(request:any) {


    try {
        const response = yield call(aoiServices.favoriteGetAll, request.payload);
        if(response.status === 200){
	      
            yield put({
                type:mapConstants.FavoriteGetAllSuccess,
                payload : response.data

            });
        }else{
            yield put({
                type:mapConstants.FavoriteGetAllFailure,
                payload: response.response.data.errorMessage
            });
        }      
      } catch (error) {
        yield put({
            type:mapConstants.FavoriteGetAllFailure,
            payload: error
        });
      }
  }


  export const aoiSaga = {
    userareaSaga, favoriteSaga
  }